<template>
  <Banner
    :image="ProgramacaoHomeImage"
    ariaLabel="Pessoas caminhando"
  >
    <div id="programacaoAncora"></div>
    <div class="programacaoHome">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <TitleSection color="#fff">
              Programação
            </TitleSection>
          </div>
          <div class="col-12 col-lg-6">
            <img class="img-fluid d-none d-lg-block" :src="ProgramacaoHomeTimelineDesktop">
            <img class="img-fluid d-lg-none" :src="ProgramacaoHomeTimelineMobile">
          </div>
          <div class="col-12 col-lg-5 text-lg-right">
            <img class="img-fluid" :src="PremiacaoProgramacaoHome">
            <!-- <div class="button">
              <router-link :to="{ name: 'inscrevase' }">
                <Button big :minWidth="250">Inscreva-se aqui</Button>
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </Banner>
</template>

<script>
import PremiacaoProgramacaoHome from '@/images/premiacaoProgramacaoHome.svg'
import ProgramacaoHomeTimelineDesktop from '@/images/programacaoHomeTimelineDesktop.svg'
import ProgramacaoHomeTimelineMobile from '@/images/programacaoHomeTimelineMobile.svg'
import ProgramacaoHomeImage from '@/images/programacaoHomeEBannerDicas.jpg'
import Banner from '@/components/Banner'
import Button from '@/components/Button'
import TitleSection from '@/components/TitleSection'
import HomeInfoParte1 from '@/images/homeInfoParte1.svg'
import HomeInfoParte2 from '@/images/homeInfoParte2.svg'

export default {
  name: 'programacaoHome',
  components: {
    Banner,
    TitleSection,
    Button,
  },
  data: () => ({
    ProgramacaoHomeTimelineDesktop,
    ProgramacaoHomeTimelineMobile,
    ProgramacaoHomeImage,
    PremiacaoProgramacaoHome,
    HomeInfoParte1,
    HomeInfoParte2,
  })
}
</script>

<style lang="scss" scoped>
.programacaoHome {
  padding-bottom: 100px
}
.text-lg-right {
  text-align: right;
  @media (max-width: 992px) {
    text-align: center;
    margin-top: 30px;
  }
}
.button {
  margin-top: 30px
}
</style>
